const computed = {
  computed: {
    internalBgColor () {
      return this.bgColor === 'white' ? this.$dark ? 'bg-gray-800' : 'bg-white' : this.setBgColor()
    },
    internalTextColor () {
      return this.color === 'black' ? this.$dark ? 'text-white' : 'text-black' : this.setTextColor()
    },
    internalLabelColor () {
      return this.labelColor === 'black' ? this.$dark ? 'text-white' : 'text-black' : this.setTextColor('labelColor', 'labelColorLightness')
    }
  }
}

export default computed



// WEBPACK FOOTER //
// ./src/bcq-ui/mixins/computed.js